import clsx from 'clsx';
import React, { ReactElement, ReactNode } from 'react';

interface ButtonGroupProps {
  children: ReactNode;
  className?: string;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({ children, className }) => {
  return (
    <span
      className={`inline-flex rounded-md shadow-sm ${className}`}
      role="group"
      aria-label="button group"
    >
      {React.Children.map(children, (child) =>
        React.cloneElement(child as ReactElement, {
          className: clsx(
            '-ml-px rounded-none first:ml-auto first:rounded-l-md last:rounded-r-md',
            (child as ReactElement).props.className,
          ),
        }),
      )}
    </span>
  );
};

export default ButtonGroup;
